<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-refresh"></span> Sync Progress</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>
  <div class="content">
    <div class="margin-top-16">

      <div class="row justify-content-between mb-2">
        <div class="col-4 d-flex">
          <input type="text" pInputText placeholder="Search..." [(ngModel)]="search"
            (input)="applyFilter()" style="width: 350px;">
          <i class="fa fa-times mt-2" style="margin-left: -24px; cursor: pointer;"
            *ngIf="search" (click)="clearFilter()"></i>
        </div>
        <div class="col-auto">
          <button pButton label="" style="width:50px;" icon="pi pi-refresh" (click)="loadData()" [disabled]="loading"></button>
        </div>
      </div>

      <p-table [value]="pagedData" [rows]="limit" [scrollable]="true" scrollHeight="750px">
        <ng-template pTemplate="header">
          <tr>
            <th class="headers-table" *ngFor="let col of columns">{{ formatColumnHeader(col) }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td *ngFor="let col of columns">{{ formatCellValue(row[col]) }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columns.length || 1">
              {{ loading ? 'Loading...' : 'No sync progress data available.' }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        #paginator
        [rows]="limit"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 25, 50]"
        (onPageChange)="paginate($event)">
      </p-paginator>

    </div>
  </div>
</div>
